export const ALLOWED_NICHES = 5;
export const MAX_NICHES_MESSAGE = "Content can be added to a maximum of 5 niches";
export const NOT_AVAILABLE_MESSAGE = "Content has been previously removed from this niche";
